import { css } from '@emotion/react'
import { Button, Cell, Grid, HFlow, TableCell, TableRow, Text } from 'bold-ui'
import { blue } from 'bold-ui/lib/styles/colors'
import { useAlert } from 'components/alert'
import { Form, FormRenderProps, TextField } from 'components/form'
import { confirm } from 'components/modals/confirm'
import { FormApi } from 'final-form'
import { useSalvarLoteImunobiologicoMutation } from 'graphql/hooks.generated'
import { useServerTime } from 'hooks/useServerTime'
import { metaPath } from 'util/metaPath'

import { ImunobiologicoSelectField } from '../components/ImunobiologicoSelectField'
import { LoteImunobiologicoFabricanteSelectField } from '../components/LoteImunobiologicoFabricanteSelectField'
import { LoteImunobiologicoFormModel } from '../insert/LoteImunologicoTooltipAddForm'
import convertModelToInput from '../LoteImunoModelnputConverter'
import { LoteImunobiologicoModel } from '../model'
import { validateLoteImunobiologico } from '../validator/validator-loteImunobiologico'
import { LoteImunobiologicoValidadeDateField } from './LoteImunobiologicoValidadeDateField'

interface LoteImunobiologicoEditInlineFormRowProps {
  row: LoteImunobiologicoModel
  reload(): Promise<any>
  onEditChange(): void
}

export default function LoteImunobiologicoEditInlineFormRow(props: Readonly<LoteImunobiologicoEditInlineFormRowProps>) {
  const { row, reload, onEditChange } = props

  const { getServerTimeNow } = useServerTime()
  const serverTimeNow = getServerTimeNow()

  const alert = useAlert()

  const [salvar] = useSalvarLoteImunobiologicoMutation()

  const path = metaPath<LoteImunobiologicoFormModel>()

  const renderForm = (formProps: FormRenderProps<LoteImunobiologicoFormModel>) => {
    const isFabricanteLegado = !formProps?.values?.fabricante?.codigoRnds
    return (
      <TableRow style={{ height: '15rem', backgroundColor: blue.c90 }}>
        <TableCell colSpan={6}>
          <Text component='b' fontSize={1}>
            Editar lote de imunobiológico
          </Text>

          <Grid
            style={css`
              margin-top: 1rem;
            `}
          >
            <Cell md={2} lg={2}>
              <TextField name={path.lote} label='Lote' maxLength={30} required />
            </Cell>
            <Cell md={3} lg={4}>
              <LoteImunobiologicoFabricanteSelectField name={path.fabricante} label='Fabricante' required />
            </Cell>
            <Cell md={4} lg={4}>
              <ImunobiologicoSelectField name={path.imunobiologico} label='Imunobiológico' disabled={true} semRegras />
            </Cell>
            <Cell md={3} lg={2}>
              <LoteImunobiologicoValidadeDateField
                name={path.validade}
                minDate={serverTimeNow}
                required
                disabled={isFabricanteLegado}
              />
            </Cell>
          </Grid>
          <HFlow justifyContent='flex-end' style={{ marginTop: '1.5rem' }}>
            <Button size='small' onClick={onEditChange}>
              Cancelar
            </Button>
            <Button size='small' kind='primary' onClick={handleSubmit(formProps)}>
              Salvar
            </Button>
          </HFlow>
        </TableCell>
      </TableRow>
    )
  }

  const handleSubmit = (formProps: FormRenderProps<LoteImunobiologicoFormModel>) => () => {
    if (
      row.lote === formProps.values?.lote &&
      row.fabricante.nome === formProps.values.fabricante?.nome &&
      row.imunobiologico.id === formProps.values.imunobiologico?.id &&
      row.validade === formProps.values?.validade
    ) {
      onEditChange()
    } else {
      confirm({
        title: 'Deseja confirmar a edição?',
        body: 'A edição deste lote de imunobiológico irá alterar todos os registros de vacinação relacionados a ele.',
        cancelLabel: 'Cancelar',
        confirmLabel: 'Salvar',
        onConfirm: () => {
          formProps.handleSubmit()
        },
      })()
    }
  }

  const submitForm = (form: LoteImunobiologicoFormModel, formApi: FormApi) => {
    return salvar({ variables: { input: convertModelToInput(form) } }).then(() => {
      alert('success', 'Lote de imunobiológico foi atualizado com sucesso.')
      setTimeout(formApi.reset)
      reload()
      onEditChange()
    })
  }

  return (
    <Form<LoteImunobiologicoFormModel>
      render={renderForm}
      onSubmit={submitForm}
      validate={validateLoteImunobiologico(serverTimeNow)}
      initialValues={row}
    />
  )
}
